/* ==========================================================
   Firki Wala – Product gallery carousel fix (Shopify Dawn)
   Thumbnails, prev/next arrows, counter, swipe and keyboard
   all drive one active slide.
   Save as assets/custom-gallery.js
   ========================================================== */
(function () {
  'use strict';

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.fwReady === '1') return;

    var list = gallery.querySelector('.product__media-list');
    if (!list) return;
    var slides = Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
    if (slides.length < 2) return;

    gallery.dataset.fwReady = '1';

    var prevBtn = gallery.querySelector('.slider-button--prev');
    var nextBtn = gallery.querySelector('.slider-button--next');
    var counterNow = gallery.querySelector('.slider-counter--current');
    var counterAll = gallery.querySelector('.slider-counter--total');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.thumbnail-list__item'));
    var thumbWrap = gallery.querySelector('.thumbnail-list');
    var current = 0;
    var scrollTimer = null;
    var isHover = false;

    /* 1. Make every slide the same square frame (slide 5 is landscape and leaves grey bars) */
    slides.forEach(function (slide) {
      var box = slide.querySelector('.product__media');
      if (box) box.style.setProperty('padding-top', '100%', 'important');
    });
    if (counterAll) counterAll.textContent = slides.length;

    /* 2. Core: show slide n */
    function go(n, smooth) {
      current = Math.max(0, Math.min(slides.length - 1, n));
      list.scrollTo({ left: current * list.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
      render();
    }

    /* 3. Sync UI with the current slide */
    function render() {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });

      thumbs.forEach(function (t, i) {
        var btn = t.querySelector('button') || t;
        btn.setAttribute('aria-current', i === current ? 'true' : 'false');
        t.classList.toggle('is-active', i === current);
      });

      if (counterNow) counterNow.textContent = current + 1;
      if (prevBtn) { prevBtn.disabled = current === 0; prevBtn.toggleAttribute('disabled', current === 0); }
      if (nextBtn) { nextBtn.disabled = current === slides.length - 1; nextBtn.toggleAttribute('disabled', current === slides.length - 1); }

      /* keep the active thumbnail visible without moving the whole page */
      var t = thumbs[current];
      if (t && thumbWrap) {
        var horizontal = thumbWrap.scrollWidth > thumbWrap.clientWidth && thumbWrap.scrollHeight <= thumbWrap.clientHeight + 2;
        if (horizontal) {
          thumbWrap.scrollTo({ left: t.offsetLeft - (thumbWrap.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
        } else {
          thumbWrap.scrollTo({ top: t.offsetTop - (thumbWrap.clientHeight - t.offsetHeight) / 2, behavior: 'smooth' });
        }
      }
    }

    /* 4. Intercept Dawn's own click handlers (capture phase) so only ours runs */
    gallery.addEventListener('click', function (e) {
      var arrow = e.target.closest('.slider-button');
      if (arrow && gallery.contains(arrow) && !arrow.closest('.thumbnail-slider')) {
        e.preventDefault(); e.stopPropagation();
        go(current + (arrow.name === 'next' ? 1 : -1));
        return;
      }
      var thumb = e.target.closest('.thumbnail-list__item');
      if (thumb) {
        e.preventDefault(); e.stopPropagation();
        var i = thumbs.indexOf(thumb);
        if (i > -1) go(i);
      }
    }, true);

    /* 5. Swipe / trackpad scroll updates the active slide */
    list.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var i = Math.round(list.scrollLeft / list.clientWidth);
        if (i !== current) { current = Math.max(0, Math.min(slides.length - 1, i)); render(); }
      }, 80);
    }, { passive: true });

    /* 6. Keyboard arrows while the pointer is over the gallery */
    gallery.addEventListener('mouseenter', function () { isHover = true; });
    gallery.addEventListener('mouseleave', function () { isHover = false; });
    document.addEventListener('keydown', function (e) {
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (/INPUT|TEXTAREA|SELECT/.test(tag)) return;
      if (!isHover && !gallery.contains(document.activeElement)) return;
      if (e.key === 'ArrowRight') go(current + 1);
      if (e.key === 'ArrowLeft') go(current - 1);
    });

    /* 7. Keep position correct when the window is resized */
    window.addEventListener('resize', function () { go(current, false); });

    /* 8. Variant picker (if the product ever has variant images) */
    gallery.addEventListener('fw:goto', function (e) { go(e.detail, true); });

    go(0, false);
  }

  function boot() {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', boot);                       /* fallback if Dawn builds the gallery late */
  document.addEventListener('shopify:section:load', boot);     /* theme editor re-render */
})();